export   const replyBodyStyle = () => {
    const _style =
       {
            backgroundColor : "#f3f2f1",
            color: "black",
            marginLeft: "100px",
            marginRight: "20px",
            marginTop: "5px",
            lineHeight: "18pt"
        }                    
    return _style;
  };


export  const replyStyle = () => {
    const _style =
       {
            marginTop: "1px",
            borderBottom: "1px solid lightBlue",
            borderTop: "1px solid lightBlue"                          
        };
    return _style;
  };